import { useLocalization } from '@magicdoorinc/ui';
import { createMemo } from 'solid-js';
import { useFilters, useConnectionStatusFilter } from '~/components/filters';
import { mode, PaymentMode } from '~/hooks/usePaymentMode';
import type { FilterItems } from '@magicdoorinc/ui';
import type { FiltersOpts } from '~/components/filters';
import type { FilterValue } from '~/components/filters/types';
import type { BankAccountConnectionStatus } from '~/swagger/portal/Api';

export type BankAccountsFilterValue = FilterValue & {
  plaidLinkStatus?: 'All' | BankAccountConnectionStatus;
  stripeLinkStatus?: 'All' | BankAccountConnectionStatus;
  connectionStatus?: 'All' | BankAccountConnectionStatus;
};

export const useBankAccountsFilter = (opts?: FiltersOpts<BankAccountsFilterValue>) => {
  const { t } = useLocalization();
  const filterOwner = useFilters<BankAccountsFilterValue>(opts);

  const filterItems = createMemo<FilterItems<BankAccountsFilterValue>>(() => {
    if (mode() === PaymentMode.Pay) {
      return [useConnectionStatusFilter(filterOwner, 'connectionStatus', t('Payment processor status'))];
    }

    return [
      useConnectionStatusFilter(filterOwner, 'plaidLinkStatus', t('Plaid link status')),
      useConnectionStatusFilter(filterOwner, 'stripeLinkStatus', t('Stripe link status')),
    ];
  });

  return {
    ...filterOwner,
    filterItems,
  };
};
